import {
  automationsDisplayName,
  eventTypeDescription,
  Pegasus,
} from 'corso-types';
import { useLocation } from 'react-router-dom';
import { useAutomationsForEventType } from '~/features/settings/hooks/useAutomations';
import { useStoreId } from '~/providers/StoreUserProvider';
import { eventTypeIcon } from './automationsContent';
import AutomationRuleList from './AutomationsList';

export function AutomationListByEventType({
  eventType,
  emptyText,
  hideIcon = false,
  draggable = false,
}: {
  eventType: Pegasus.EventType;
  emptyText?: string;
  hideIcon?: boolean;
  draggable?: boolean;
}) {
  const location = useLocation();
  const storeId = useStoreId();
  const automations = useAutomationsForEventType(eventType);

  // intentionally not wrapped with a card, as this optionally delegated to where it's used
  return (
    <AutomationRuleList
      automations={automations}
      icon={hideIcon ? undefined : (eventTypeIcon[eventType] ?? 'aiInline')}
      label={automationsDisplayName.eventType[eventType]}
      description={eventTypeDescription[eventType]}
      createTo={{
        pathname: `/${storeId}/settings/automations/create`,
        search: new URLSearchParams({
          eventType,
          returnTo: location.pathname,
        }).toString(),
      }}
      draggable={draggable}
      emptyText={emptyText}
    />
  );
}
